import React from "react";
import PropTypes from "prop-types";

function UserJobTitle(props) {
  const { full_name, profile } = props;

  return (
    <React.Fragment>
      <h2 id='object-name' className='font-weight-bold'>{full_name}</h2>
      { profile.job_title && <p id='object-position'>{profile.job_title}</p> }
    </React.Fragment>
  );
}

UserJobTitle.propTypes = {
  full_name: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    job_title: PropTypes.string
  }).isRequired
};

export default UserJobTitle;
